import React, {useState, useEffect}  from 'react'
import MediaQuery from 'react-responsive';
import { DFPSlotsProvider, AdSlot } from 'react-dfp';
import { Online } from 'react-detect-offline';
import IsNotDomestic from 'helpers/IsNotDomestic';
import globalJSON from 'data/global.json'
// import Hero from '../Hero';


// import AdBillboard from './AdBillboard'
// import AdLeaderboard from './AdLeaderboard'
// import AdMpu from './AdMpu'

// styles
import classes from './Advert.module.scss'

const Advert = (props) => {
	let [adColumn, setAdColumn] = useState(globalJSON.advertising.column);
	function getColumn(){
		if(props.column !== undefined){
			return props.column
		}else{
			return globalJSON.advertising.column
		}
	}
	useEffect(() => {
		setAdColumn(getColumn);
    }, [])
	return (		
		<section>
			<IsNotDomestic>
				<Online>
					<MediaQuery maxWidth={classes.screenMdMax}>
						<DFPSlotsProvider targetingArguments={{ column: adColumn}} dfpNetworkId={`${globalJSON.advertising.networkID}`} adUnit={`${globalJSON.advertising.adUnit}`}>
							<div className={`MPU__Wrapper`}>
								<div className={`MPU__mpu`}>
									<p className={`ads_title MPU__Title`}>advertisement</p>
									<div className={`MPU__Ads`}>
										<AdSlot sizes={[ [300, 250] ]} />
									</div>
								</div>
							</div>
						</DFPSlotsProvider>
					</MediaQuery>

					<MediaQuery minWidth={classes.screenMd}>
						<DFPSlotsProvider targetingArguments={{ column: adColumn }} dfpNetworkId={`${globalJSON.advertising.networkID}`} adUnit={`${globalJSON.advertising.adUnit}`}>
							<div className={`leaderboardWrapper`}>
								<div className={`leaderboard`}>
									<p className={`ads_title leaderboardTitle`}>advertisement</p>
									<div className={`leaderboardAds`}>
										<AdSlot sizes={[ [728, 90] ]} />
									</div>
								</div>
							</div>
						</DFPSlotsProvider>
					</MediaQuery>

				</Online>
			</IsNotDomestic>
		</section>
	)
	
}

export default Advert